import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type OnboardingStep = 
  | 'WELCOME'
  | 'BUSINESS_TYPE'
  | 'VISION'
  | 'BRAND'
  | 'OPERATIONS'
  | 'COMPLETE';

interface OnboardingState {
  currentStep: OnboardingStep;
  completedSteps: OnboardingStep[];
  businessType: 'new' | 'existing' | null;
  setCurrentStep: (step: OnboardingStep) => void;
  completeStep: (step: OnboardingStep) => Promise<void>;
  setBusinessType: (type: 'new' | 'existing') => void;
  reset: () => void;
}

export const useOnboardingStore = create<OnboardingState>()(
  persist(
    (set) => ({
      currentStep: 'WELCOME',
      completedSteps: [],
      businessType: null,

      setCurrentStep: (step) => set({ currentStep: step }),
      
      completeStep: async (step) => {
        set((state) => ({
          completedSteps: [...state.completedSteps, step],
          currentStep: step === 'WELCOME' ? 'BUSINESS_TYPE' :
                      step === 'BUSINESS_TYPE' ? 'VISION' :
                      step === 'VISION' ? 'BRAND' :
                      step === 'BRAND' ? 'OPERATIONS' : 'COMPLETE'
        }));
      },

      setBusinessType: (type) => set({ 
        businessType: type,
        currentStep: 'VISION',
        completedSteps: ['WELCOME', 'BUSINESS_TYPE']
      }),
      
      reset: () => set({
        currentStep: 'WELCOME',
        completedSteps: [],
        businessType: null
      })
    }),
    {
      name: 'onboarding-storage'
    }
  )
);